<template>
  <v-container class="white-wrapper" fluid>
    <div class="bottom-text"  v-html="$t('pay.scan_do_it')">
      <!-- 키오스크에 바코드를 <a href="/#/buy">스캔</a>하세요. -->
    </div>
    <div class="img-container">
      <!-- <div class="btn-wrapper">
        <v-btn
          text
          color="primary"
          @click="clickRefresh"
          class="font-weight-bold"
          :disabled="!show"
        >
          새로고침<v-icon>mdi-refresh</v-icon>
        </v-btn>
      </div> -->
      <transition name="fade">
        <div v-show="show">
          <v-fade-transition leave-absolute>
            <vue-q-r-code-component
           style="margin:0 auto;"
              :size="200"
              :text="jsonData"
              class="qr-code"
            />
          </v-fade-transition>
          <vue-barcode
            width="1"
            class="barcode"
            :value="jsonData"
            :display-value="false"
          />
        </div>
      </transition>
      <div style="width: 340px">
        <v-menu offset-y>
          <template v-slot:activator="{ on, attrs }">
            <v-btn color="primary" v-bind="attrs" v-on="on" x-large block>
              <v-icon class="mr-1">mdi-refresh</v-icon>
              <div
                class="d-flex align-center justify-space-between font-weight-bold mx-4"
                style="width: 100%"
              >
                <div>{{ selectedCoin.name }}</div>
                <div>{{ comma(selectedCoin.balance) }}</div>
              </div>
            </v-btn>
          </template>
          <v-list>
            <v-list-item
              v-for="(item, index) in wallet"
              :key="index"
              @click="clickCoin(item)"
            >
              <div
                class="d-flex justify-space-between font-weight-bold mx-4"
                style="width: 100%"
              >
                <div>{{ item.name }}</div>
                <div>{{ comma(item.balance) }}</div>
              </div>
            </v-list-item>
          </v-list>
        </v-menu>
      </div>
    </div>
    
  </v-container>
</template>

<script>
import VueQRCodeComponent from 'vue-qrcode-component'
import VueBarcode from 'vue-barcode'

export default {
  components: { VueQRCodeComponent, VueBarcode },
  data: () => ({
    nowTime: new Date().getTime(),
    timer: '',
    show: true,
    duration: 10000,
    selectedCoin: null,
    coinName: 'UMCP'
  }),
  computed: {
    user() {
      return this.$store.getters.user
    },
    jsonData() {
      return JSON.stringify({
        uid: this.user.id,
        now: this.nowTime,
        token: this.coinName
      })
    },
    myWalletAdress() {
      return this.$store.getters.user.wallet_address
    },
    wallet() {
      
      console.log( "store.getters.wallet : " ,  this.$store.getters.wallet )
      let _temp = this.$store.getters.wallet.filter(
        (i) => i.name !== 'USDT' && i.name !== 'ETH' && i.name !== 'USDT-TRC' && i.name !== 'PCC'  && i.name !== 'PGP' //&& i.name !== 'ETH'
        // (i) => i.name == 'BNB' && i.name == 'UMUC' && i.name == 'UMCP' && i.name == 'TRX'  
      ) ;

      // console.log( " _temp :"  ,_temp ) ;

      let _tempAry = [] ; 
      // let _sort = ["W3P","W3C","CCC","ETH","USDT","TRX","MATIC","LSS" , "STAIKA"] ;  //,"HLM" ,"PCC","PGP","PRTG"
      let _sort = ["BNB","UMCP","UMSC","TRX"] ;  // "UMUC", ,"HLM" ,"PCC","PGP","PRTG"

      _temp.map((item , i) => {        
        _tempAry[_sort.indexOf(item.name) ] = item ; 
      }) ; 

      // console.log(_tempAry) ;
      return _tempAry //Ary
    }
  },
  methods: {
    refresh() {
      this.nowTime = new Date().getTime()
      this.show = true
      this.coinName = this.selectedCoin.name
    },
    fadeRefresh() {
      this.show = false
      setTimeout(this.refresh, 500)
    },
    clickCoin(item) {
      this.selectedCoin = item
      this.fadeRefresh()
      clearInterval(this.timer)
      this.timer = setInterval(this.fadeRefresh, this.duration)
    }
  },
  created() {
    // this.$store.commit('loading', false)

    this.timer = setInterval(this.fadeRefresh, this.duration)
    this.selectedCoin = this.wallet.filter((i) => i.name === 'UMCP')[0]
  }
}
</script>

<style lang="scss" scoped>
.fade-enter-active,
.fade-leave-active {
  transition: opacity 0.5s;
}
.fade-enter, .fade-leave-to /* .fade-leave-active below version 2.1.8 */ {
  opacity: 0;
}
.btn-wrapper {
  display: flex;
  justify-content: flex-end;
  margin-bottom: 1rem;
  padding: 0 1rem;
  width: 100%;
}
.img-container {
  display: flex;
  flex-direction: column;
  align-items: center;
  height: calc(100vh - 196px);
  overflow: auto;
  padding: 3rem 0 1rem;
}
.barcode {
  display: flex;
  justify-content: center;
  margin: 1.5rem 0 0;
  max-width: 350px !important;
}
.bottom-text {
  position: absolute;
  // bottom: 0;
  // height: 60px;
  width: 100%;  
  height: 30px;
  background: #e9e9e9;
  font-weight: bold;
  display: flex;
  justify-content: center;
  align-items: center;
}
</style>
